import { object, string } from 'zod';

export const schemaEmail = object({
  email: string().email({ message: 'Instituição Inválida' }),
});
